// @flow

import styled, { css } from "styled-components";
import { fontMedium } from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";
import Button from "../../_atom/Buttons/button";
import { generateTransition, easeInOut } from "../../_static/Transitions";

export const ListContainer = styled.div`
  background-color: ${buildColor("blue_accent", "000")};
  padding: 8px;
`;

export const ListHolder = styled.div`
  ${(props) =>
    !props.paddingless &&
    css`
      padding: 8px 8px 0 8px;
    `};
  ${(props) =>
    props.paddingBottom &&
    css`
      padding: 8px;
    `};
  background-color: ${buildColor("blue", "000")};
  ${(props) =>
    props.isHandicappingPastPerformance &&
    css`
      padding: 0;
      border-radius: 4px;
      border: 1px solid ${buildColor("blue", "100")};
      background-color: ${buildColor("white", "0")};
      box-shadow: inset 0 -1px 0 ${buildColor("blue", "100")};
      box-shadow: 0 2px 4px ${buildColor("blue", "100")},
        0 1px 2px ${buildColor("blue", "100")};
    `};

  &.expandable {
    overflow: hidden;
    transition: ${generateTransition(easeInOut, "max-height")};

    &.expand-inside-enter {
      max-height: 95px;
    }

    &.expand-inside-enter-active {
      max-height: 1000px;
    }

    &.expand-inside-enter-done {
      max-height: 1000px;
    }
  }
`;

export const ListWrapper = styled.div`
  background-color: ${buildColor("white", "100")};
  ${(props) =>
    !props.borderless &&
    css`
      border: ${({ isHandicappingPastPerformance }) =>
        isHandicappingPastPerformance
          ? `0`
          : `1px solid ${buildColor("grey", "300")}`};
      border-radius: 2px;
    `};
`;

export const MoreButton = styled(Button)`
  width: 100%;
`;

export const LoadingState = styled.div`
  padding: 2px;
  height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const MatchHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  height: 48px;
  padding: 0 8px;
  background-color: ${buildColor("white", "100")};
  border-bottom: 1px solid ${buildColor("blue", "100")};
`;

export const EmptyStateContainer = styled.div`
  height: 48px;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoadingMessage = styled.div`
  font-size: 12px;
  color: ${buildColor("grey", "900")};
  padding-top: 8px;
`;

export const IconContainer = styled.div`
  padding-left: 3px;
  height: 16px;
`;

export const PastPerformanceStatusContainer = styled.div`
  padding: 8px 12px;
  background-color: ${buildColor("white", "100")};
`;

export const RunnerFlagsContainer = styled.div`
  border-top: 1px solid ${buildColor("blue", "100")};
  padding: 8px 12px 5px;
`;

export const HorseOddsContainer = styled.div`
  border-top: 1px solid ${buildColor("blue", "100")};
  ${({ isLoading }) =>
    !isLoading &&
    css`
      border-bottom: 1px solid ${buildColor("blue", "100")};
    `};
  background-color: ${buildColor("white", "100")};
  padding: 8px 12px;
`;

export const OpenPPModalButton = styled(Button)`
  height: 44px;
  background-color: ${buildColor("white", "100")};

  &:focus,
  &:focus-within,
  &:active {
    background-color: ${buildColor("blue_accent", "200")};
  }

  && > span {
    font-size: 14px;
    color: ${buildColor("blue_accent", "500")};
    font-family: ${fontMedium};
    font-weight: normal;
    text-transform: capitalize;
  }
`;

export const OpenPPModalArrow = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
`;
